import axios from "axios";

import { baseUrl } from "services/client";

export async function fetchDonationMonthlyHistory() {
  return await axios.get(`${baseUrl}donation-monthly-history/`);
}


